/* eslint-disable @typescript-eslint/no-redeclare */
export const FETCH_POLICIES_LOADING = 'FETCH_POLICIES_LOADING';
export type FETCH_POLICIES_LOADING = typeof FETCH_POLICIES_LOADING;
export const FETCH_POLICIES_SUCCESS = 'FETCH_POLICIES_SUCCESS';
export type FETCH_POLICIES_SUCCESS = typeof FETCH_POLICIES_SUCCESS;
export const FETCH_POLICIES_FAILURE = 'FETCH_POLICIES_FAILURE';
export type FETCH_POLICIES_FAILURE = typeof FETCH_POLICIES_FAILURE;
